<template>
  <marquee-text :duration="30">
    {{text}}
  </marquee-text>
</template>

<script>
export default {
  name:"marquee",
  props: {
    text:String
  }
}
</script>